import { DateTime } from "luxon"

import type { KPIGroupRequest } from "@/types/kpiTypes.ts"

export const getDates = (request: KPIGroupRequest, asOf?: Date) => {
  const dates: string[] = []
  let startDate: DateTime<true> | DateTime<false> = DateTime.now().startOf("day")
  if (asOf != undefined) {
    startDate = DateTime.fromJSDate(asOf) || DateTime.now().startOf("day")
  }
  if (request.returnSize != undefined) {
    for (let i = 0; i < request.returnSize; i++) {
      let currentDay = startDate.minus({
        days: request.returnSize - (1 + i),
      })
      if (request.aggType == "Monthly") {
        currentDay = startDate.startOf("month").minus({
          months: request.returnSize - (1 + i),
        })
      } else if (request.aggType == "Weekly") {
        currentDay = startDate.startOf("week").minus({
          weeks: request.returnSize - (1 + i),
        })
      }
      dates.push(currentDay.toISODate() || "")
    }
  }
  return dates
}
